module.exports = __webpack_public_path__ + "static/media/ic_edit.4d0f9137.svg";